<template>
	<div class="modul father-module">
		<div class="title-module flex flex-align-center flex-pack-justify">
			<img src="@/assets/image/layout/mod-title.png" alt="" class="title-module-img" />
			<div>{{ sensorName }}</div>
			<div class="tabs flex flex-align-center" v-if="tabs.length > 1">
				<div class="tab" @click="changeTab(item)" :class="{ active: curTab == item }" v-for="(item, index) in tabs" :key="index">{{ item }}</div>
			</div>
		</div>
		<div class="charts"></div>
		<!-- <div class="modul-content">
			<div class="echarts-box">
				<div class="modul-content-title">数据折线图</div>
				<div class="charts"></div>
			</div>
		</div> -->
	</div>
</template>

<script>
import { EleResize } from '../../../utils/resize';
import * as echarts from 'echarts';
export default {
	name: 'bottom',
	data() {
		return {
			option: {
				color: ['#22B2FB', '#17E5DE', '#FFD300'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				grid: {
					top: '10',
					left: '5',
					right: '0',
					bottom: '10',
					containLabel: true
				},
				calculable: true,
				xAxis: [
					{
						type: 'category',
						axisTick: { show: false },
						data: [],
						axisLabel: {
							show: true,
							color: '#F4FAFF',
							fontSize: 11,
							interval: 0,
							align: 'center'
						},
						axisLine: {
							//不显示坐标轴线
							show: true,
							lineStyle: {
								color: '#2F5A8D'
							}
						},
						axisTick: {
							show: false,
							alignWithLabel: true,
							lineStyle: {
								color: '#fff',
								type: 'solid' //线的类型。'solid' 'dashed' 'dotted'
							}
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						splitLine: {
							//网格线
							lineStyle: {
								type: 'dashed', //设置网格线类型 dotted：虚线 solid:实线
								color: 'rgba(255,255,255,0.149)'
							}
							// show: true //隐藏或显示
						},
						axisLabel: {
							show: true,
							color: '#F4FAFF',
							fontSize: 12
						}
					}
				],
				series: [
					{
						name: '处置案卷',
						type: 'line',
						symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
						showSymbol: false,
						smooth: true,
						lineStyle: {
							normal: {
								width: 1,
								color: '#17E5DE' // 线条颜色
							}
						},
						itemStyle: {
							show: false
						},
						symbolSize: 2, //设定实心点的大小
						areaStyle: {
							normal: {
								//线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[
										{
											offset: 0,
											color: 'rgba(23, 229, 222, 1)'
										},

										{
											offset: 1,
											color: 'rgba(23, 229, 222, 0)'
										}
									],
									false
								)
							}
						},
						data: []
					}
				]
			},
			echart: null,
			sensorName: '',
			dingshi: null,
			shujuData: null,
			tabs: [],
			curTab: '',
			arrayTwo: {}
		};
	},

	async mounted() {
		// 创建ECharts实例
		this.ChartOne();
		this.dingshi = setInterval(item => {
			this.getSensorByNameAndCreateTime();
		}, 60000);
	},
	watch: {},
	computed: {},
	methods: {
		//图表
		async ChartOne() {
			this.echart = this.$echarts.init(document.querySelector('.charts'));
			let dom = document.querySelector('.charts');
			if (dom) {
				EleResize.on(dom, this.echart.resize);
				this.echart.setOption(this.option);
				// let xLabel = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
				// let dataValue = [20, 30, 40, 35, 34, 15, 56, 15, 12, 25, 34, 42];
				// let dataValue1 = [40, 35, 34, 15, 56, 15, 12, 25, 34, 42, 20, 30];
				// this.echart.setOption();
			}
		},
		// 获取实测数据
		async getSensorByNameAndCreateTime(sensorName) {
			if (sensorName && sensorName != '') {
				this.sensorName = sensorName;
			}
			let data = {
				pageSize: 20,
				pageNum: 1, //当前页数
				// startTime: '',
				sensorName: this.sensorName,
				startTime: this.$moment()
					.subtract(1, 'd')
					.format('YYYY-MM-DD HH:mm:ss'),
				endTime: this.$moment().format('YYYY-MM-DD HH:mm:ss')
			};
			// console.log(data);
			const res = await this.$api.sendPost('/dataDhSensor/getSensorByNameAndCreateTime', data);
			if (res.errcode === 0) {
				// console.log(res);

				// 转换后的二维数组
				this.arrayTwo = res.data.list.reduce((res, item) => {
					res[item.dataTypeName] ? res[item.dataTypeName].push(item) : (res[item.dataTypeName] = [item]);
					return res;
				}, {});
				/* 如果 arrayTwo大于1则需要tab切换*/
				this.tabs = Object.keys(this.arrayTwo);
				if (this.tabs && this.tabs.length > 0) {
					this.changeTab(this.tabs[0]);
				}
			} else {
				this.tableData = [];
			}
		},
		qingchudingshiqi() {
			console.log('xiaoshi1>>>', this.dingshi);
			clearInterval(this.dingshi);
			this.dingshi = null;
		},
		changeTab(curTab) {
			console.log('%c [ curTab ]-212', 'font-size:13px; background:pink; color:#bf2c9f;', curTab);
			// if (this.curTab == curTab) {
			// 	return;
			// }
			this.curTab = curTab;
			let dateArr = [];
			let dataValue = [];
			this.arrayTwo[this.curTab].map(item => {
				dateArr.push(item.createTime.split(' ').pop());
				dataValue.push(item.dataValue);
			});
			console.log('%c [ dateArr ]-255', 'font-size:13px; background:pink; color:#bf2c9f;', dateArr);
			this.option.yAxis[0].min = Math.min(...dataValue);
			this.option.series[0].name = curTab;
			// 创建时间
			this.option.xAxis[0].data = dateArr.reverse();
			// 数值
			this.option.series[0].data = dataValue.reverse();
			this.ChartOne();
		}
	},
	destroyed() {
		console.log('xiaoshi2>>>', this.dingshi);
		clearInterval(this.dingshi);
		this.dingshi = null;
	}
};
</script>

<style lang="scss" scoped>
.charts {
	height: 280px;
}

.modul-search {
	text-align: left;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
}

.modul-content-title {
	margin: 20px 0;
	text-align: left;
	font-size: 16px;
	font-weight: 350;
	color: #fff;
	line-height: 24px;
}

.echarts-box {
	width: 100%;
	height: 300px;
}

.tabs {
	.tab {
		margin: 0 20px;
		font-weight: 400;
		cursor: pointer;
		padding: 5px 10px;
		border-radius: 5px;

		&.active {
			background: #fff;
			color: rgba(11, 80, 217, 0.8);
		}
	}
}

// ::v-deep .el-dialog__body {
// 	height: 700px;
// }

// .bridge-data {
// 	overflow-y: auto;
// 	height: 600px;
// 	display: grid;
// 	grid-gap: 30px 25px;
// 	grid-template-columns: 260px 260px 260px 260px;
// 	padding-right:30px;
// }

// .bridge-list {
// 	height: 500px;
// }

// .el-tree {
// 	padding-top: 15px;
// 	background: #f7f7f7;
// }
</style>
